import Vue from 'vue'
import Vuex from 'vuex'

import Service from '@/service/metro_editor'

Vue.use(Vuex)

const DefaultOption = {
    fillColor: '#00b0ff',
    strokeColor: '#80d8ff',
    fillOpacity: 0.3
}

const evtList = ['delete', 'adjust', 'split', 'union'];

let polyEditor

let eventCallback

let polyline

const resetLine = () => {
    if (polyEditor) {
        polyEditor.delete()
        polyEditor.destroy()
    }
}

const createEditor = (state, { line_style, coordinate}) => {
    const latlngBounds = new window.TMap.LatLngBounds()
    const paths = coordinate.map((poi) => {
        const [lng, lat] = poi.split(',')
        const latlng = new window.TMap.LatLng(lat, lng)
        latlngBounds.extend(latlng)
        return latlng
    })
    polyEditor = new window.TMap.tools.GeometryEditor({
        map: window.map,
        overlayList: [
            {
                overlay: new window.TMap.MultiPolyline({
                    map: window.map,
                    styles: {
                        highlight: new window.TMap.PolylineStyle({
                            color: 'rgba(255, 255, 0, 0.6)'
                        }),
                        dashed_line: new window.TMap.PolylineStyle({
                            dashArray: line_style === 'dashed_line' ? [10, 10] : [0, 0]
                        })
                    },
                    geometries: [
                        {
                            paths,
                            styleId: 'dashed_line'
                        }
                    ]
                }),
                id: 'polyline',
                selectedStyleId: 'highlight'
            }
        ],
        actionMode: window.TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
        activeOverlayId: 'polyline', // 激活图层
        selectable: true, // 开启点选功能
        snappable: true // 开启吸附
    })
    window.map.fitBounds(latlngBounds, {
        padding: 24
    })
    evtList.forEach(evtName => {
        polyEditor.on(evtName + '_complete', evtResult => {
            const line = evtResult.paths.map((poi) => {
                return [poi.lng ,poi.lat].join(',')
            })
            state.editing_line.trackways[state.selected_line].coordinate = line
        })
    })

    polyEditor.on('split_fail', (res) => {
        alert(res.message);
    })
    polyEditor.on('union_fail', (res) => {
        alert(res.message);
    })
}

export default {
    namespaced: true,
    state: {
        editing_line: {
            name: '一号线',
            trackways: [],
            metro_stations: [
            ]
        },
        selected_line: -1,
        selected_station: -1,
        marker: null
    },
    mutations: {
        addLine (state, line_params) {
            if (!state.editing_line.trackways) {
                state.editing_line.trackways = []
            }
            state.editing_line.trackways.push(line_params)
            state.selected_line = state.editing_line.trackways.length - 1
            resetLine()
            createEditor(state, line_params)

        },
        selectLine (state, index) {
            state.selected_line = index
            resetLine()
            createEditor(state, state.editing_line.trackways[index])
        },
        delLine (state) {
            state.editing_line.trackways.splice(state.selected_line, 1)
            state.selected_line = -1
            resetLine()
        },
        init (state, data) {
            state.editing_line = data
            const latlngBounds = new window.TMap.LatLngBounds()
            const geometries = data.metro_stations.map((station, i) => {
                const [ lng, lat ] = station.location.split(',')
                const point = new window.TMap.LatLng(lat, lng)
                latlngBounds.extend(point)
                return {
                    "id": `metro-${i}`,
                    "styleId": "marker",
                    "position": point,
                    "properties": {
                        "title": "metro"
                    }
                }
            })
            state.marker = new window.TMap.MultiMarker({
                id: "metro-marker",
                map: window.map,
                styles: {
                    "marker": new window.TMap.MarkerStyle({
                        "width": 25,
                        "height": 35,
                        "anchor": { x: 16, y: 32 },
                        "src": "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png"
                    }),
                    "marker_selected": new window.TMap.MarkerStyle({
                        "width": 25,
                        "height": 35,
                        "anchor": { x: 16, y: 32 }
                    })
                },
                geometries: geometries
            })
            window.map.fitBounds(latlngBounds, {
                padding: 24
            })
        },
        selectStation (state, selected_station) {
            this.selected_station = selected_station
            const { metro_stations } = state.editing_line
            const { location } = metro_stations[selected_station]
            const [lng, lat] = location.split(',')
            const geometries = state.marker.getGeometries().map((item) => {
                return {
                    ...item,
                    styleId: item.id === `metro-${selected_station}` ? 'marker_selected' : 'marker',
                    rank: item.id === `metro-${selected_station}` ? 2 : 1
                }
            })
            state.marker.updateGeometries(geometries)
            window.map.setCenter(new window.TMap.LatLng(lat, lng))
        }
    },
    actions: {
        async init ({ commit }, id) {
            const { data } = await Service.getDetail(id)
            commit('init', data)
        },
        selectStation ({ commit }, index) {
            commit('selectStation', index)
        },
        addLine ({ commit }, points) {
            commit('addLine', points)
        },
        selectLine ({ commit }, index) {
            commit('selectLine', index)
        },
        delLine ({ commit }) {
            commit('delLine')
        }
    }
}
